/**
 * 予算・計画・実績画面　予算・計画・実績表検索条件VOクラス
 */
export class KYMW1307GetSummaryTableModel {

  public displayMode: string = null;                                            // 表示モード
  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分
  public sellAreaCode: string = null;                                           // 売場コード
  public orderNumQuotaCode: string = null;                                      // 注文コード割当コード
  public coopCode: string = null;                                               // 生協コード
  public classCode: string = null;                                              // 部門コード
  public middleClassCode: string = null;                                        // 中分類コード
  public smallClassCode: string = null;                                         // 小分類コード
  public pageNum: string = null;                                                // ページ番号
  public buyerCode: string = null;                                              // バイヤーコード
  public nonCarryFlag: string = null;                                           // 未掲載フラグ
  public orderClientCode: string = null;                                        // 発注先コード
  public orderClientKanji: string = null;                                       // 発注先名称
  public payeeClientCode: string = null;                                        // 支払先コード
  public payeeClientKanji: string = null;                                       // 支払先名称

}
